<template>
  <div class="main_contract_part" :class="{is_sub: isSub}" :style="'--level_gap: ' + ((level ?? 0) * 7) + 'px;'">
    <span class="num_part" v-text="part.hierarchicalNumber"></span>
    <div class="card_b legal_details" :class="{active: part?.isOpen}">
        <div class="head">
            <div class="title_actions">
                <h3>
                    <span v-text="'פרק: ' + part.title" v-if="!part?.edit_mode"></span>
                    <input type="text" v-else v-model="part.title" @blur="part.edit_mode=false; save()">
                </h3>
                <div class="actions">
                    <div class="edit_con" @click="part.edit_mode = true;">
                        <i class="fas fa-edit"></i>
                    </div>
                    <div class="delete_con" @click="deletePart(part)">
                        <i class="fas fa-trash-alt"></i>
                    </div>
                    <div class="add_part_con" @click="$emit('addPart', part.id)">
                        <i class="fas fa-plus"></i>
                    </div>

                </div>
            </div>
            <div class="arrow_headers">
                <div class="headers" v-if="part?.isOpen && !isSub">
                    <span>תנאי סף</span>
                    <span>חשיבות הסעיף</span>
                    <span :data-tooltip="get_word('compensation_clause_info', true)" :d="get_word('compensation_clause_info', true)">
                        סעיף תמורה
                        <i class="fas fa-info-circle"></i>
                    </span>
                </div> 
                <div class="icon" @click="part.isOpen=!part?.isOpen" :class="part?.isOpen ? 'chevron_up_blue_icon' : 'chevron_down_blue_icon'"></div>
            </div>
        </div>
        <div class="content">
            <div class="parts_container">
                <div class="sub_part" v-for="(subPart) in this.partComp.parts" :key="subPart.id">
                    <contractPart  
                        @save="save" 
                        @addClause="addClause($event, part.id)" 
                        @addPart="$emit('addPart', $event)" 
                        :partComp="subPart"  
                        :index="index"
                        :level="(level ?? 0)+1"
                    />
                </div>
            </div>
            <div class="clauses_container">
                <div class="clause" v-for="(clause,i) in clausesComp" :class="{edit_mode: clause.edit_mode}" :key="clause.id">
                    <div class="text_edit_container">
                        <!-- <div class="edit_btn_container" @click="clause.edit_mode = true">
                            <span class="icon edit_b_icon"></span>
                        </div> -->
                        <div class="num" v-text="clause.hierarchicalNumber"></div>
                        <div class="text_input_container">
                            <textarea v-model="clause.content" :disabled="!clause.edit_mode" placeholder="כאן מכניסים את הטקסט" rows="2" @input="adjustHeight($event.target)" ref="textareas" ></textarea>
                        </div>
                    </div>
                    <div v-show="!clause.edit_mode" class="theme-switch-wrapper mid">
                        <!-- <span>כן</span> -->
                        <label class="theme-switch"  :for="id+'-'+i">
                            <input v-model="clause.is_must" type="checkbox" :id="id+'-'+i" @change="clause.points = 3" />
                            <div class="slider round"></div>
                        </label>
                        <!-- <span>לא</span> -->
                    </div>
                  

                    <select v-model="clause.points" v-show="!clause.edit_mode">
                        <option value="1">נמוכה</option>
                        <option value="2">בינונית</option>
                        <option value="3">גבוהה</option>
                    </select>
                    <div v-show="!clause.edit_mode" class="theme-switch-wrapper mid">
                        <!-- <span>כן</span> -->
                        <label class="theme-switch"  :for="id+'-2'+i">
                            <input v-model="clause.is_answer" type="checkbox"  :id="id+'-2'+i" />
                            <div class="slider round"></div>
                        </label>
                        <!-- <span>לא</span> -->
                    </div>
                    <div class="actions" v-show="!clause.edit_mode">
                        <div class="edit_con" @click="clause.edit_mode = true">
                            <i class="fas fa-edit"></i>
                        </div>
                        <div class="icon delete_con" @click="deleteClause(clause)">
                            <i class="fas fa-trash-alt"></i>
                        </div>
                        
                    </div>
                      <div class="btn_b text_s" v-show="clause.edit_mode" @click="clause.edit_mode = false;save()"> שמירה </div>
                    <div class="btn_b cancel_btn text_s" v-show="clause.edit_mode && clause.content !== clause.original_content" @click="clause.content = clause.original_content; clause.edit_mode = false;save()"> ביטול ושיחזור הניסוח המקורי </div>
                </div>

                <div class="clause add_clause" >
                    <div class="title">
                        <p>
                            <span>הוספת סעיפים</span>
                            <span>(אופציונאלי)</span>
                        </p>
                    </div>
                    <div class="fields">
                        <div class="text_input_container">
                            <textarea  placeholder="כאן מכניסים את הטקסט" rows="2" v-model="temp.content" @input="adjustHeight($event.target)" ref="tempTextarea" ></textarea>
                        </div>
                        <select v-model="temp.points">
                            <option value="1">נמוכה</option>
                            <option value="2">בינונית</option>
                            <option value="3">גבוהה</option>
                        </select>
                        <div class="btn_b text_s" v-show="temp.content.length" @click="saveTemp"> שמירה </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['partComp', 'index', 'level'],
    data() {
        return {
            temp:{points: 1, content: '' , original_content: '', is_must: false,id: this.random_id(),new: true,is_answer: false},
            id: this.random_id(),
            part: this.partComp,
            boxOpen: false,
            addClauseInput: '',
            isSub: this.level > 0,
            partNum: this.level > 0 ? this.index+1 : this.numToHebrew(this.index+1)
        }
    },
    watch: {
        // boxOpen: {
        //     handler: function () {
        //         this.updateTextareasHeight();
        //     }
        // },
      part: {
          handler: function (val) {
              this.$emit('update', val);
                this.updateTextareasHeight();
          },
          deep: true
      }
    },
    computed: {
        clausesComp() {
            return this.partComp ? this.partComp.clauses.filter(clause => !clause.delete) : [];
        }
    },
    mounted() {
        this.updateTextareasHeight();
    },
    methods: {
        deletePart(part) {
            this.confirm(this.get_word('delete_part'), this.get_word('ok_delete'),this.get_word('cancel_delete')).then((result) => {
                if (result) {
                    part.delete = true;
                    this.save();
                }
            });
            
        },
        deleteClause(clause) {
            this.confirm(this.get_word('delete_clause'), this.get_word('ok_delete'),this.get_word('cancel_delete')).then((result) => {
                if (result) {
                    clause.delete = true;
                    this.save();
                }
            });
            
        },
        updateTextareasHeight() {
            this.$nextTick(() => {
                if (this.$refs.textareas) {
                    const textareas = Array.isArray(this.$refs.textareas) 
                        ? this.$refs.textareas 
                        : [this.$refs.textareas];
                    
                    textareas.forEach(textarea => {
                        if (textarea) this.adjustHeight(textarea);
                    });
                }
                
                if (this.$refs.tempTextarea) {
                    this.adjustHeight(this.$refs.tempTextarea);
                }
            });
        },
        adjustHeight(element) {
            // Reset height to auto to get the correct scrollHeight
            element.style.height = 'auto';
            // Set the height to match the content
            element.style.height = `${element.scrollHeight}px`;
            
        },
        saveTemp() {
            this.temp.original_content = this.temp.content;
            this.part.clauses.push({...this.temp});
            this.temp = {points: 1, content: '', original_content: '', is_must: false, id: this.random_id(), new: true, is_answer: false};
            this.save();
        },
        save() {
            this.$emit('save', this.part);
        },
        random_id() {
            return Math.random().toString(36).substring(2, 12);
        },
      
    }
}
</script>

<style lang="scss" scoped>
.main_contract_part { display: flex; align-items: center; gap: var(--gap);
    &.is_sub {
        // & { margin-right: var(--level_gap);}
        .card_b { border-radius: 0; }  
    }
    &>.num_part {   }
    .card_b { flex: 1;
        >.content { padding: 0;}
        .head {
            &:hover {
                .title_actions {
                    .actions { opacity: 1; pointer-events: all;
                        
                    }
                }
            }
            .title_actions { display: flex; gap: var(--gap); 
                .actions { opacity: 0; pointer-events: none; transition: 0.2s ease opacity; display: flex; gap: var(--gap); align-items: center;
                    i, svg { width: 18px; height: 18px; cursor: pointer;}
                    .edit_con {  font-size: 18px;
                        i, svg {color: #0b4f73;}
                    }
                    .delete_con { font-size: 18px;
                        i, svg {color: #ff0000;}
                    }
                    .add_part_con { font-size: 18px;
                        i, svg {color: #02b96d;}
                    }
                }
            }
            .arrow_headers {
                span { display: flex; align-items: center; gap: var(--gap_small);
                    i, svg { color: #B2C8D3 !important; }
                }
            }
        }
    }
    .parts_container { display: flex; flex-direction: column; 
        .sub_part { padding: var(--gap_small); padding-right: 32px; }
    }
    .clauses_container { display: flex; flex-direction: column;
        .clause { display: flex; align-items: center; gap: var(--gap_big); padding: 8px 32px 8px 32px; 
            
            &.edit_mode { background: #F4F4F5;
            }
            .btn_b { width: 90px; font-size: var(--h5);}
            .cancel_btn { width: 150px; background: transparent;}
            &:not(:last-child) { border-bottom: 1px solid var(--pageBG);}
            &:hover {
                .text_edit_container {
                    .edit_btn_container { opacity: 1;}
                }
                .actions { opacity: 1;}
            }
            &.add_clause { flex-direction: column; align-items: flex-start; gap: var(--gap_small);
                .title {
                    p {display: flex; gap: 5px;}
                }
                .fields {    width: 100%; display: flex; align-items: center; gap: var(--gap_xmid);
                    
                }
            }
            .actions { display: flex; justify-content: flex-end; gap: var(--gap); width: 90px; opacity: 0;
                i, svg { cursor: pointer;}
                .delete_con { font-size: 18px;
                    i, svg {color: #ff0000;}
                }
                .edit_con {  font-size: 18px;
                    i, svg {color: #0b4f73;}
                }
            }
            .text_edit_container, .text_input_container {flex: 1; display: flex; align-items: center; gap: var(--gap);
                .edit_btn_container { cursor: pointer; opacity: 0; display: flex; align-items: center; justify-content: center; width: 40px; height: 40px; background: #F4F4F5; border-radius: 50%; 
                    .icon {width: 60%; height: 60%;}
                } 
            }
            .text_input_container { border: 1px solid var(--pageBG); border-radius: var(--radius_s); 
                input, textarea {padding-inline: 24px; padding-block: 0; width: 100%; height: 3.5em; line-height: 1.2em; font-size: var(--h5); border: none;}
                textarea { min-height: 3.5em; // Minimum height
                    resize: none; // Prevent manual resizing
                    overflow: hidden; // Hide scrollbar
                    transition: height 0.1s ease; // Smooth height transition
                    }
            }
            >select, .fields select {width: 140px;}
        }
    }
}
</style>